export const RESOURCE_NAME = 'user_aggregation';
